import {StructuredTextDocument} from 'react-datocms';
import {isHeading} from 'datocms-structured-text-utils';

export interface Heading {
  id: string;
  text: string;
}

interface StructuredTextNode {
  type: string;
  level?: number;
  children?: StructuredTextNode[];
  value?: string;
  [key: string]: unknown;
}

export const generateHeadingId = (text: string): string => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};

export const extractTextFromNode = (
  node: StructuredTextNode | string,
): string => {
  if (typeof node === 'string') {
    return node;
  }

  if (!node?.children || !Array.isArray(node.children)) {
    return '';
  }

  return node.children
    .map((child: StructuredTextNode | string) => {
      if (typeof child === 'string') {
        return child;
      }
      return child.value || '';
    })
    .join('');
};

export const extractH2Headings = (
  document: StructuredTextDocument,
): Heading[] => {
  if (!document) return [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const docWithValue = document as any;
  const nodes = docWithValue.value?.document?.children;

  if (!Array.isArray(nodes)) {
    return [];
  }

  const findHeadings = (nodeArray: StructuredTextNode[]): Heading[] => {
    return nodeArray.flatMap(node => {
      const nodeHeadings: Heading[] = [];

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (isHeading(node as any) && node.level === 2) {
        const text = extractTextFromNode(node);
        if (text.trim()) {
          nodeHeadings.push({
            id: generateHeadingId(text),
            text: text.trim(),
          });
        }
      }

      if (node?.children && Array.isArray(node.children)) {
        nodeHeadings.push(...findHeadings(node.children));
      }

      return nodeHeadings;
    });
  };

  return findHeadings(nodes);
};
